var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isListenerMobile)?_c('ListenerAlbumDetails'):_c('AlbumDetails')
}
var staticRenderFns = []

export { render, staticRenderFns }